import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

export const getUserQuota = async (email: string): Promise<{
  dailyUsed: number;
  monthlyUsed: number;
  totalUsed: number;
  dailyQuota: number;
  monthlyQuota: number;
}> => {
  try {
    const response = await axios.get(`${API_URL}/quota/check`, {
      params: { sender: email }
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération du quota :", error);
    throw error;
  }
};

export const updateUserQuota = async (
  email: string,
  dailyQuota: number,
  monthlyQuota: number
): Promise<any> => {
  try {
    const response = await axios.put(`${API_URL}/quota/update`, {
      email,
      dailyQuota,
      monthlyQuota,
    });
    console.log("Mise à jour du quota :", response.data);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour du quota :", error);
    throw error;
  }
};
